/**
 * Cached public surface for `/{username}` — Website vs Link-in-Bio.
 * Avoids flashing the wrong product on repeat visits while bootstrap revalidates.
 */

export type CreatorPublicSurface = "website" | "link-in-bio";

const CACHE_PREFIX = "creator_public_surface_v4:";

function cacheKey(username: string): string {
  return `${CACHE_PREFIX}${String(username || "").trim().toLowerCase()}`;
}

export function readCachedCreatorPublicSurface(
  username: string,
): CreatorPublicSurface | null {
  const key = String(username || "").trim();
  if (!key || typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(cacheKey(key));
    if (raw === "website" || raw === "link-in-bio") return raw;
  } catch {
    // ignore
  }
  return null;
}

export function writeCachedCreatorPublicSurface(
  username: string,
  surface: CreatorPublicSurface,
): void {
  const key = String(username || "").trim();
  if (!key || typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(cacheKey(key), surface);
  } catch {
    // ignore
  }
}
